import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export function KedalamanScroll({ children, className = "", testid }) {
  const ref = useRef(null);
  const mengurangiGerak = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 0.5, 1], [14, 0, -8]);
  const putarX = useTransform(scrollYProgress, [0, 0.5, 1], [2, 0, -1]);
  const skala = useTransform(scrollYProgress, [0, 0.5, 1], [0.99, 1, 0.995]);

  return (
    <motion.div
      ref={ref}
      data-testid={testid}
      className={`scroll-depth relative ${className}`.trim()}
      style={
        mengurangiGerak
          ? undefined
          : {
              y,
              rotateX: putarX,
              scale: skala,
              transformPerspective: 1300,
            }
      }
    >
      {children}
    </motion.div>
  );
}

export function MunculSaatTerlihat({ children, className = "", delay = 0, testid }) {
  const mengurangiGerak = useReducedMotion();

  return (
    <motion.div
      data-testid={testid}
      className={className}
      initial={mengurangiGerak ? false : { opacity: 0, y: 20 }}
      whileInView={mengurangiGerak ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}